export default [
  {
    path: "/admin_ai_prompts",
    name: "admin_ai_prompts",
    component: () => import("./AiPromptsView.vue"),
    meta: {
      tabAccess: "ADMIN",
    },
  },
  {
    path: "/admin_ai_prompts/:name",
    name: "admin_ai_prompts_edit",
    component: () => import("./EditAiPromptView.vue"),
    meta: {
      tabAccess: "ADMIN",
    },
  },
];
